import React from 'react';
import { observer } from 'mobx-react';
const CMSIcons = observer(() => {
  const icons = [{
    name: 'close',
    icon: 'close.svg'
  }, {
    name: 'settings-white',
    icon: 'settings-white.svg'
  }, {
    name: 'app-menu',
    icon: 'app-menu.svg'
  }, {
    name: 'user-circle',
    icon: 'user-circle.svg'
  }, {
    name: 'close-white',
    icon: 'close_white.svg'
  }, {
    name: 'cross-white',
    icon: 'cross.svg',
    customCSS: 'filter: invert(1)'
  }, {
    name: 'cross-black',
    icon: 'cross.svg'
  }, {
    name: 'arrow-up',
    icon: 'arrow-down.svg',
    customCSS: 'transform: rotate(180deg);'
  }, {
    name: 'arrow-down',
    icon: 'arrow-down.svg'
  }, {
    name: 'arrow-left',
    icon: 'arrow-left.svg'
  }, {
    name: 'arrow-right',
    icon: 'arrow-right.svg'
  }, {
    name: 'arrow-left-white',
    icon: 'arrow-left-white.svg'
  }, {
    name: 'arrow-right-white',
    icon: 'arrow-right-white.svg'
  }, {
    name: 'drag',
    icon: 'drag.svg'
  }, {
    name: 'document',
    icon: 'document.svg'
  }, {
    name: 'trash',
    icon: 'trash.svg'
  }, {
    name: 'minus',
    icon: 'minus.svg'
  }, {
    name: 'plus',
    icon: 'plus.svg'
  }, {
    name: 'check-white',
    icon: 'check.svg'
  }, {
    name: 'check',
    icon: 'check.svg',
    customCSS: 'filter: invert(1)'
  }, {
    name: 'cono-interior-experience',
    icon: 'cono-interior-experience.svg'
  }, {
    name: 'avatar',
    icon: 'avatar.svg'
  }, {
    name: 'tecma',
    icon: 'tecma.svg'
  }, {
    name: 'rotate',
    icon: 'rotate.svg'
  }, {
    name: 'refresh',
    icon: 'ico-refresh.svg'
  }, {
    name: 'no-tap',
    icon: 'ico-no-tap.svg'
  }, {
    name: 'settings',
    icon: 'settings.svg'
  }, {
    name: 'edit',
    icon: 'ico-edit.svg'
  }, {
    name: 'col-1',
    icon: 'col-1.svg'
  }, {
    name: 'col-2',
    icon: 'col-2.svg'
  }, {
    name: 'green-pencil',
    icon: 'green-pencil.svg'
  }, {
    name: 'white-pencil',
    icon: 'white-pencil.svg'
  }, {
    name: 'jpg',
    icon: 'jpeg.svg'
  }, {
    name: 'mp4',
    icon: 'mp4.svg'
  }, {
    name: 'arrow-right-black',
    icon: 'arrow-right-black.svg'
  }, {
    name: 'arrow-left-gray',
    icon: 'arrow-left-gray.svg'
  }];
  const containers = ['cms-container', 'cms-snackbar', 'cms-top-bar', 'cms-app'];
  return /*#__PURE__*/React.createElement("style", null, icons.map(i => {
    const containerClasses = containers.map(c => `.${c} .${i.name}`);
    return `
                        ${containerClasses.join(',')} {
                            background-image: url(${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o" + '/CMS/img/icon/' + i.icon});
                            ${i.customCSS ? i.customCSS : ''}
                        }
                    `;
  }), `
                .gblcbk .rotate i {
                    background-image: url(${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o" + '/CMS/img/icon/rotate.svg'});
                }
            `);
});
export default CMSIcons;